module.exports = __webpack_public_path__ + "img/illustration.35edd9ed.svg";